export const ACTION_TYPES = {
    UPDATE_PAGE: 'UPDATE_PAGE'
};